/** Shared status chips for the Supplier Master List (Demo Mode only) - approval, operational,
 * certification and open-exceptions status. Kept together in one file since they're small and
 * only used by the master list table/row. See src/mocks/data/supplierMasterListData.ts. */

import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SupplierApprovalStatus } from '../../../../mocks/data/supplierGovernanceData';
import { SupplierCertificationStatus, SupplierOperationalStatus } from '../../../../mocks/data/supplierMasterListData';

const APPROVAL_COLOR: Record<SupplierApprovalStatus, 'success' | 'error' | 'warning' | 'default'> = {
  [SupplierApprovalStatus.Approved]: 'success',
  [SupplierApprovalStatus.AutoApprovedLowVolume]: 'success',
  [SupplierApprovalStatus.PendingReview]: 'warning',
  [SupplierApprovalStatus.Suspended]: 'error',
  [SupplierApprovalStatus.Rejected]: 'error',
};

export const SupplierApprovalStatusChip = ({ status }: { status: SupplierApprovalStatus }) => {
  const { t } = useTranslation('suppliers');
  return (
    <Chip label={t(`status${status}`, status)}
      size="small"
      color={APPROVAL_COLOR[status]} />
  );
};

const OPERATIONAL_COLOR: Record<SupplierOperationalStatus, 'success' | 'error' | 'warning' | 'default'> = {
  Active: 'success',
  OnHold: 'warning',
  Inactive: 'default',
  Onboarding: 'warning',
};

export const SupplierOperationalStatusChip = ({ status }: { status: SupplierOperationalStatus }) => {
  const { t } = useTranslation('suppliers');
  return (
    <Chip label={t(`status${status}`, status)}
      size="small"
      color={OPERATIONAL_COLOR[status]} />
  );
};

const CERTIFICATION_COLOR: Record<SupplierCertificationStatus, 'success' | 'error' | 'warning' | 'default'> = {
  Valid: 'success',
  ExpiringSoon: 'warning',
  Expired: 'error',
  None: 'default',
};

export const SupplierCertificationStatusChip = ({ status }: { status: SupplierCertificationStatus }) => {
  const { t } = useTranslation('suppliers');
  return (
    <Chip label={t(`status${status}`, status)}
      size="small"
      color={CERTIFICATION_COLOR[status]} />
  );
};

export const SupplierExceptionsChip = ({ count }: { count: number }) => (
  <Chip label={count}
    size="small"
    color={count === 0 ? 'success' : count >= 3 ? 'error' : 'warning'} />
);
